/**
 * Created by 17030535 on 2018/2/11.
 */
import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');

let Service = {
  /**
   * 查询关注门店状态接口
   * @params {String} storeCode    门店编码
   * @return Promise
   * */
  queryProductInfo(prdCode){
    let url = CONF.API.queryProductInfo,
      jsonpCallback = 'cb';
    url = url
      .replace('{{prdCode}}', prdCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
};
export default Service;



// WEBPACK FOOTER //
// ./src/services/PrductInfo.js